<template>
  <b-row>
    <fileProgress v-for="(file,key) in fileUpload" :key="key" :file="file" :keyServies="keyServies" :keyValue="keyValue"
      @removeFile="removeFile" @saveAttachmentTemp="saveAttachmentTemp" :allowFileSize="allowFileSize" :attachmentTypeId="attachmentTypeId" />
    <b-col cols="12" class="text-right">
      <div v-if="showButton" slot="footer" class="form-group form-btn">
        <!-- <b-button :disabled="showBtn || isBtnFinal" type="button" size="md" variant="success" @click="finalSave">
          {{$lang.submitButton}}
          <i class="fa fa-check"></i>
        </b-button> -->

        <b-button @click="finalSave" class="text-center" variant="success" :disabled="showBtn || isBtnFinal">
            <div v-if="!isBtnFinal">
               {{$lang.submitButton}} <span key="fa-check"><i class="fa fa-check"></i></span>
            </div>
            <div v-if="isBtnFinal">
              <b-spinner small></b-spinner>
              <span> {{$lang.search.loading_send}}</span>
            </div>
          </b-button>
        <b-button :disabled="showBtn || isBtnFinal" type="reset" class="ml-2" size="md" variant="danger" @click="removeFiles">
          {{$lang.cancelButton}}
          <i class="fa fa-ban"></i>
        </b-button>
      </div>
    </b-col>
  </b-row>
</template>

<script>
  /**
   * @group fileListProgress
   * این کامپوننت برای نمایش فایل‌های در حال آپلود تعریف شده است
   */
  import fileProgress from './fileProgress'
  export default {
    name: "file-list-progress", // نام کامپوننت
    components: {
      fileProgress
    },
    props: {
      isBtnFinal: {
        type: Boolean,
        default: true
      },
      fileUpload: {
        type: [Array, FileList]
      },
      allowFileSize:{
        type: Number,
        default: null
      },
      // ریسورس
      keyServies: {
        type: [String, Number],
        default: ""
      },
      // کلید ایدی یا کد 
      keyValue: {
        type: [String, Number],
        default: ""
      },
      showButton: {
        type: Boolean,
        default: true
      },
      attachmentTypeId: {
        type: [String, Number],
        default: null,
      },
    },
    data() {
      return {
        showBtn: true, // نمایش دکمه
        responseCode: [] // کد‌های فایل‌های آپلودی
      }
    },
    methods: {
      /**
       * @vuese
       * 	برای حذف تمامی فایل‌های آپلود شده
       *  @arg  بدون پارامتر
       */
      removeFiles() {

        this.$emit("removeFiles")
      },
      /**
       * @vuese
       * 	برای حذف تکی فایل آپلود شده
       *  @arg  ایدی فایل مورد حذف
       */
      removeFile(id) {
        this.$emit("removeFile", id)
      },
      /**
       * @vuese
       * 	 برای ذخیره  فایل‌های آپلود شده در تمپلیت
       *  @arg  بدون پارامتر
       */
      saveAttachmentTemp(responseCode) {
        this.showBtn = false
        this.responseCode.push(responseCode)
        this.$emit("getResponseCode", this.responseCode)
      },
      /**
       * @vuese
       * 	برای ذخیره نهایی فایل‌های آپلود شده 
       *  @arg  بدون پارامتر
       */
      finalSave() {
        this.$emit("finalSave", this.responseCode)
      }
    }
  }

</script>
